import { createSlice } from "@reduxjs/toolkit";
import { setLoader } from "./loader";
import { ProductivityApi } from "service/apiVariables";
import { Toast } from "service/toast";
import { api } from "service/api";
import { addQuery, NO_DATA } from "helpers/utis";
const today = new Date();

const past7Days = new Date();
past7Days.setDate(today.getDate() - 7);
export const productivitySlice = createSlice({
  name: "productivity",
  initialState: {
    isLoading: true,
    productivityList: [],
    selectedTrade: null,
    selectedWings: null,
    selectedProject: null,
    selectedUOM: null,
    selectedTechnician: null,
    startDate: today.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    endDate: today.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    }),
    uomData: "",
    nonProductiveTechnician: null,
    nonProductiveTrade: null,
    nonProductiveWing: null,
    nonProductiveProject: null,
    nonProductiveStartDate: null,
    nonProductiveEndDate: null,
  },
  reducers: {
    saveData: (state, action) => {
      state.productivityList = action.payload;
      state.isLoading = false;
    },
    setSelectedTrade: (state, action) => {
      state.selectedTrade = action.payload;
    },
    setSelectedWing: (state, action) => {
      state.selectedWings = action.payload;
    },
    setSelectedProject: (state, action) => {
      state.selectedProject = action.payload;
    },
    setSelectedUOMs: (state, action) => {
      state.selectedUOM = action.payload;
    },
    setSelectedTechnician: (state, action) => {
      state.selectedTechnician = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setNonProductiveTechnician: (state, action) => {
      state.nonProductiveTechnician = action.payload;
    },
    setNonProductiveTrade: (state, action) => {
      state.nonProductiveTrade = action.payload;
    },
    setNonProductiveProject: (state, action) => {
      state.nonProductiveProject = action.payload;
    },
    saveUomData: (state, action) => {
      state.uomData = action.payload;
      state.isLoading = false;
    },
    setNonProductiveStartDate: (state, action) => {
      state.nonProductiveStartDate = action.payload;
    },
    setNonProductiveEndDate: (state, action) => {
      state.nonProductiveEndDate = action.payload;
    },
  },
});

export const getAllProductivity = (params) => (dispatch) => {
  ProductivityApi.getProductivityList.addQuery = params;

  return new Promise((resolve, reject) => {
    api({ ...ProductivityApi.getProductivityList })
      .then(({ data }) => {
        dispatch(saveData(data));
        dispatch(setLoader(false));
        resolve(data);
      })
      .catch(({ message }) => {
        dispatch(setLoader(false));
        dispatch(saveData([]));
        reject(Toast({ type: "error", message }));
      });
  });
};

export const getUomDropDownAct = () => (dispatch) => {
  return new Promise((reject) => {
    api({ ...ProductivityApi.getUomDropDown })
      .then((data) => {
        dispatch(saveUomData(data));
      })
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const getAllTechnicianOption = () => () => {
  return handleApiRequest({ ...ProductivityApi.getTechnicianList });
};

export const setNonProductiveWing = () => () => {
  return handleApiRequest({ ...ProductivityApi.getTechnicianList });
};

const handleApiRequest = (apiConfig) => {
  return api(apiConfig).catch(({ message }) => {
    throw Toast({ type: "error", message });
  });
};

// download reports
export const downloadProductivity = (query) => (dispatch) => {
  addQuery(query, ProductivityApi.getProductivityList);
  return new Promise((resolve, reject) => {
    api({ ...ProductivityApi.getProductivityList })
      .then((data) => {
        resolve(data);
      })
      .catch(({ message }) => {
        if (message === NO_DATA) {
          dispatch(saveData([]));
        } else {
          reject(Toast({ type: "error", message }));
        }
      });
  });
};

export const getFilterWingsApi = (id) => () => {
  ProductivityApi.getFilterWingsOptions.query.project_id = id;
  return new Promise((resolve, reject) => {
    api({ ...ProductivityApi.getFilterWingsOptions })
      .then((data) => resolve(data))
      .catch(({ message }) => reject(Toast({ type: "error", message })));
  });
};

export const {
  saveData,
  setSelectedProject,
  setSelectedTrade,
  setSelectedWing,
  setSelectedTechnician,
  setStartDate,
  setEndDate,
  setNonProductiveTechnician,
  setNonProductiveTrade,
  setNonProductiveProject,
  setNonProductiveStartDate,
  setNonProductiveEndDate,
  saveUomData,
  setSelectedUOMs,
} = productivitySlice.actions;

export default productivitySlice.reducer;
